<template>
  <div>
    <div v-if="!isSeller" class="has-bg-grey3 is-border-bottom">
      <div class="column">
        <span class="label"></span>
        <input id="selfReminder" type="checkbox" name="selfReminder"
                class="switch is-success is-rounded" v-model="selfReminder">
        <label for="selfReminder" class="label">
          <span class="is-size-6 has-text-grey">Ce rappel est pour moi</span>
        </label>
      </div>
      <div v-if="!isSeller && ! selfReminder" class="column is-paddingless-top">
        <label for="" class="label">Utilisateur *</label>
        <multiselect v-model="reminder.user" label="email" track-by="pk"
                      :custom-label="sellerName"
                      v-validate="'required'"
                      name="user"
                      class="multiselect--option-ico"
                      :placeholder="''"
                      data-vv-as="Utilisateur"
                      :options="users" :searchable="true" :close-on-select="true" :show-labels="false"
                      @search-change="getUsers">
          <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
          <span slot="noOptions">La liste est vide</span>
        </multiselect>
        <p v-if="errors.has('user')" class="help is-danger">
          {{errors.first('user')}}
        </p>
      </div>
    </div>
    <div class="column is-12 is-paddingless is-padding-top is-padding-bottom has-bg-light">
      <label class="label is-padding-left">Programmer rappel dans :</label>
      <div class="column is-12 columns is-variable is-1 is-multiline is-paddingless-top is-paddingless-bottom">
        <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)"
              v-for="(d, i) in reminderDateList" :key="i">
          <input :id="d.value" v-model="preselectedDate" :value="d.value" name="typeRdv" @input="selectedDate(d.value)" @click="selectedDate(d.value)"
                  checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
          <label :for="d.value">{{d.label}}</label>
        </div>
      </div>
    </div>
    <div class="column is-paddingless-bottom">
      <label class="label">Programmer à une date précise :</label>
      <div class="field has-addons">
        <div class="control">
          <a class="button is-square is-static is-border is-min-width-0">
            <span class="icon"><i class="fas fa-calendar-alt"></i></span>
          </a>
        </div>
        <div class="control is-expanded has-icons-right">
          <flat-pickr v-validate="'required'" @input="checkDate(date)"
                      :class="{'is-danger': errors.has('date')}"
                      :config="configDate" v-model="date" class="input is-radiusless" name="date">
          </flat-pickr>
          <p v-if="errors.has('date')" class="help is-danger">{{errors.first('date')}}</p>
        </div>
        <div class="control">
          <a class="button is-square is-radiusless" @click="deleteDate">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="column is-paddingless-bottom">
      <label class="label">Programmer à une heure précise :</label>
      <div class="field has-addons">
        <div class="control">
          <a class="button is-square is-static is-border is-min-width-0">
            <span class="icon"><i class="fas fa-clock"></i></span>
          </a>
        </div>
        <div class="control is-expanded has-icons-right">
          <flat-pickr @input="checkHour(hour)"
                      :config="configHour" v-model="hour" class="input is-radiusless" name="hour">
          </flat-pickr>
        </div>
        <div class="control">
          <a class="button is-square is-radiusless" @click="deleteHour">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="column is-paddingless-bottom">
      <v-input id="title" name="title" @input="val => reminder.title = val" :model="reminderTitle"
                label="Nom du rappel *"
                v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Titre">
      </v-input>
    </div>
    <div class="columns is-vcentered is-multiline">
      <div class="column is-12">
        <label for="" class="label">Note (optionnel)</label>
        <textarea class="textarea" id="note" name="note" v-model="reminder.note" label="Note"></textarea>
      </div>
    </div>
    <span v-if='iCanSubmit'></span>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { isNil, debounce } from 'lodash'
  import moment from 'moment'
  import { DefaultValues } from '@/mixins'

  const emptyReminder = {
    pk: null,
    title: null,
    date: null,
    user: null,
    note: null
  }

  export default {
    name: 'NewReminderCalendar',
    props: {
      source: {
        type: Object,
        default: () => {},
        required: false
      },
      initialDate: {
        type: String,
        required: false
      },
      defaultTitle: {
        type: String
      }
    },
    mixins: [DefaultValues],
    data () {
      return {
        reminder: {},
        selfReminder: true,
        users: [],
        date: null,
        hour: '07:00',
        configDate: {
          minDate: 'today',
          altInput: true,
          altFormat: 'j M Y',
          dateFormat: 'Z'
        },
        configHour: {
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: true
        },
        preselectedDate: null
      }
    },
    computed: {
      ...mapState(['currentUserPk']),
      ...mapGetters(['isAdmin', 'isManager', 'isSeller', 'isOperator']),
      iCanSubmit () {
        let canSubmit = this.errors.any() === false && this.reminder.title !== null && this.reminder.title !== '' && this.reminder.title !== undefined
        this.$emit('iCanSubmit', canSubmit)
        return canSubmit
      },
      reminderTitle () {
        if (this.defaultTitle) this.reminder.title = this.defaultTitle
        return this.reminder.title
      }
    },
    methods: {
      deleteDate () {
        this.date = null
        this.preselectedDate = null
      },
      deleteHour () {
        this.hour = null
        let newDate = moment(this.date).set({'hour': 7, 'minute': 0})
        this.date = newDate._d
      },
      checkDate (date) {
        if (date === null || date === '') this.preselectedDate = null
        this.date = date
        let formatDate = moment.utc(date).format('YYYY/MM/DD')
        if (this.preselectedDate !== formatDate) this.preselectedDate = null
      },
      checkHour (hour) {
        this.hour = hour
        let splitHour = hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let newDate = moment(this.date).set({'hour': hTime, 'minute': mTime})
        this.date = newDate._d
      },
      selectedDate: debounce(function (date) {
        this.date = date
        let splitHour = this.hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let formatDate = moment(date).set({'hour': hTime, 'minute': mTime})
        this.date = formatDate._d
      }, 200),
      sellerName (seller) {
        if (seller && seller.last_name) {
          let name = seller.first_name + ' ' + seller.last_name
          if (seller.company_name) {
            name = name + ' (' + seller.company_name + ')'
          }
          return name
        } else {
          return 'Selectionnez un vendeur'
        }
      },
      getUsers (query = null) {
        let filters = {
          first_name: query
        }
        this.$api.userService.get(filters).then(r => {
          this.users = r.data.items
        })
      },
      submit () {
        if (this.iCanSubmit) {
          if (!this.selfReminder && isNil(this.reminder.user)) {
            this.$notify({
              type: 'is-danger',
              text: 'Veuillez sélectionner un utilisateur.'
            })
            return
          }
          if (!this.date && !this.preselectedDate) {
            this.$notify({
              type: 'is-danger',
              text: 'Veuillez sélectionner une date.'
            })
            return
          }
          this.$validator.validateAll().then((valid) => {
            if (valid) {
              if (this.selfReminder) {
                this.reminder.user = null
              }
              // this.reminder.date = moment.utc(this.date)
              this.reminder.date = moment(this.date)
              let hour = document.querySelector('.flatpickr-hour').value
              let minute = document.querySelector('.flatpickr-minute').value
              let newDate = moment(this.reminder.date).set({'hour': hour, 'minute': minute})
              this.reminder.date = newDate._d
              this.reminder.date = moment.utc(this.reminder.date).format('DD/MM/YYYY HH:mm')
              if (this.source && 'event' in this.source && this.source.event) {
                this.reminder.custom_fields = {
                  rdv: this.source.event
                }
              }
              this.$api.reminderService.post(this.reminder).then(r => {
                this.$emit('submit', {reminder: r.data})
                this.$notify({
                  type: 'is-success',
                  text: 'Le rappel a été créé.'
                })
              }).catch(err => {
                console.log(err)
              })
            } else {
              this.$notify({
                type: 'is-danger',
                text: 'Erreur Le formulaire est invalide.'
              })
            }
          })
        }
      }
    },
    created () {
      this.getUsers()
      if (!isNil(this.source)) {
        Object.assign(this.reminder, this.source)
        this.date = moment().hours(7).minute(0).second(0).toDate()
      } else {
        Object.assign(this.reminder, emptyReminder)
        if (this.initialDate) {
          this.date = moment(this.initialDate, 'DD/MM/YYYY').hours(7).minute(0).second(0).toDate()
        } else {
          this.date = moment().hours(7).minute(0).second(0).toDate()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/NewReminderCalendar.vue